import {Inject, Injectable} from "@angular/core";
import * as cc from 'currency-codes';
import {CountryService} from "../country/country.service";
import {Subject} from "rxjs";
import {IS_BROWSER} from "../utils/injectiontokens";
import {NavigationService} from "../navigation/navigation.service";
import {LocalStorageService} from "../storage/local-storage.service";

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  public currencies: any[] = [];
  public currentCurrency: any;

  public supportedCurrencies: any[] = ['EUR', 'USD'];
  public defaultCurrency = "EUR"; //in case the user's country currency is not supported

  public currencySubject$: Subject<any> = new Subject<any>();

  constructor(protected countryService: CountryService,
              protected navigationService: NavigationService,
              protected storageService: LocalStorageService,
              @Inject(IS_BROWSER) protected isBrowser: boolean) {

    let selectedCurrencyIsoCode = null;
    if(this.countryService.getSelectedCountry() != null) {
      selectedCurrencyIsoCode = this.countryService.getSelectedCountry().currency.split(",");
      //filter currencies not in supportedCurrencies array
      selectedCurrencyIsoCode = selectedCurrencyIsoCode.filter(currency => this.supportedCurrencies.indexOf(currency) > -1);
      if(selectedCurrencyIsoCode.length == 0) {
        selectedCurrencyIsoCode = [this.defaultCurrency];
      }
    }
    else {
      selectedCurrencyIsoCode = [this.defaultCurrency];
    }

    if(this.isBrowser) {
      this.currentCurrency = this.storageService.getObject("currency");
      if(this.currentCurrency != null) {
        this.currencySubject$.next(this.currentCurrency);
      }
    }

    cc.codes().forEach(code => {

      let currencyInfo = cc.code(code);
      //check if currencyInfo.code is either EUR or USD
      if(this.supportedCurrencies.indexOf(currencyInfo.code) > -1) {
        let currency = {
          name: currencyInfo.currency,
          code: currencyInfo.code,
          imageFile: currencyInfo.code.toLowerCase() + '.svg'
        }
        if(this.currentCurrency == null && selectedCurrencyIsoCode.indexOf(currencyInfo.code) > -1) {
          this.currentCurrency = currency;
          this.currencySubject$.next(this.currentCurrency);
          this.saveData();
        }
        this.currencies.push(currency);
      }
    });

    //not sort countries array by country name
    this.currencies.sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      return 0;
    });

    //finally honor the query params just in case
    this.navigationService.queryParams$.subscribe(queryParams => {
      //check if queryParams contains crypto:
      if(queryParams != null && queryParams['fiat'] != null) {
        this.setSelectedCurrency(queryParams['fiat'].toUpperCase());
      }
    });



  }

  public getCurrencies() {
    return this.currencies;
  }

  public getCurrency(code: string): any {
    return this.currencies.find(currency => currency.code === code);
  }

  public setSelectedCurrency(code: any) {
    this.currentCurrency = this.getCurrency(code);
    this.currencySubject$.next(this.currentCurrency);
    this.saveData();
  }

  public getSelectedCurrency(): any {
    return this.currentCurrency;
  }

  public saveData() {
    if(this.isBrowser) {
      this.storageService.setObject('currency', this.currentCurrency);
    }
  }

}
